<div class="login-wrapper p-component" [ngClass]="{'mobile-padding': !bs.isDesktop}">
    <!-- Background layers -->
    <div class="login-bg-image"></div>
    <div class="login-bg-overlay"></div>

    <div class="login-content-container fade-in-up">
        
        <!-- Left Branding side (hidden on small mobile) -->
        <div class="branding-panel" *ngIf="bs.isDesktop">
            <div class="branding-content">
                <img *ngIf="!demo" id="client-logo-large" src="../../../assets/img/client/clientLogo.png" alt="Logo cliente" class="mb-4">
                <img class="demo-large mb-4" *ngIf="demo" src="../../../assets/img/static/biworklims.svg" alt="Logo Biwork">
                
                <h1 class="font-light text-color text-5xl mb-2 mt-0">Portal de Pacientes</h1>
                <p class="text-color-secondary text-xl font-light">Crea tu cuenta para acceder a tus resultados.</p>
            </div>
        </div>

        <!-- Right Form side (Glass Card) -->
        <div class="form-panel glass-card overflow-y-auto">
            
            <div class="blue-bw mb-4">
                <h1 class="font-light text-3xl md:text-3xl m-0 mb-1 text-color">Registrate</h1>
                <h2 class="font-semibold text-xl md:text-2xl m-0 text-primary" *ngIf="text">{{ text }}</h2>
            </div>

            <form [formGroup]="form" class="flex flex-column gap-4 w-full">
                
                <!-- Personal Info Section -->
                <div class="grid grid-nogutter gap-3">
                    <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)" *ngIf="checkShowControl('register', 'name')">
                        <p-floatlabel>
                            <input pInputText id="name" formControlName="name" class="w-full" [disabled]="isLoading" />
                            <label for="name">Nombre</label>
                        </p-floatlabel>
                        <small class="p-error" *ngIf="form.controls.name.invalid && form.controls.name.touched">{{ getErrorMessage(form.controls.name) }}</small>
                    </div>

                    <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)" *ngIf="checkShowControl('register', 'lastName')">
                        <p-floatlabel>
                            <input pInputText id="lastName" formControlName="lastName" class="w-full" [disabled]="isLoading" />
                            <label for="lastName">Apellido</label>
                        </p-floatlabel>
                        <small class="p-error" *ngIf="form.controls.lastName.invalid && form.controls.lastName.touched">{{ getErrorMessage(form.controls.lastName) }}</small>
                    </div>

                    <div class="col-12" *ngIf="checkShowControl('register', 'dni')">
                        <p-floatlabel>
                            <input pInputText id="dni" formControlName="dni" class="w-full" [disabled]="isLoading" />
                            <label for="dni">DNI</label>
                        </p-floatlabel>
                        <small class="p-error" *ngIf="form.controls.dni.invalid && form.controls.dni.touched">{{ getErrorMessage(form.controls.dni) }}</small>
                    </div>

                    <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)" *ngIf="checkShowControl('register', 'birthDate')">
                        <p-floatlabel>
                            <p-datepicker id="birthdate" formControlName="birthdate" [maxDate]="maxDate" [showIcon]="true" appendTo="body" styleClass="w-full" inputStyleClass="w-full"></p-datepicker>
                            <label for="birthdate">Fecha nacimiento</label>
                        </p-floatlabel>
                    </div>

                    <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)" *ngIf="checkShowControl('register', 'affiliateNumber')">
                        <p-floatlabel>
                            <input pInputText id="affiliateNumber" formControlName="affiliateNumber" class="w-full" />
                            <label for="affiliateNumber">Nº afiliado</label>
                        </p-floatlabel>
                    </div>

                    <div class="col-12" *ngIf="checkShowControl('register', 'affiliateNumber')">
                        <p-floatlabel>
                            <p-select id="socialWork" [options]="opts.patient_socialWorkSG()" formControlName="socialWork" optionLabel="value" optionValue="id" [filter]="true" filterBy="value" [showClear]="true" styleClass="w-full" placeholder="Obras Sociales"></p-select>
                            <label for="socialWork">Obras Sociales</label>
                        </p-floatlabel>
                    </div>
                </div>

                <!-- Address Section -->
                <div class="surface-border border-top-1 pt-4" formGroupName="address">
                    <h3 class="text-xs font-semibold text-color-secondary uppercase tracking-widest mb-4 mt-0">Dirección</h3>
                    <div class="flex flex-column gap-4">
                        <p-floatlabel>
                            <input pInputText id="addressLine" formControlName="address" class="w-full" />
                            <label for="addressLine">Calle y número</label>
                        </p-floatlabel>

                        <div class="grid grid-nogutter gap-3">
                            <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)">
                                <p-floatlabel>
                                    <p-select id="state" [options]="filteredStates()" formControlName="state" optionLabel="value" optionValue="id" [filter]="true" filterBy="value" [showClear]="true" styleClass="w-full" (onChange)="stateGroupValueChanged($event, 'loadingAddressCities', 'filteredCities', 'address')" (onClear)="clearCity()"></p-select>
                                    <label for="state">Provincia</label>
                                </p-floatlabel>
                            </div>

                            <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)">
                                <p-floatlabel>
                                    <p-select id="city" [options]="filteredCities()" formControlName="city" optionLabel="value" optionValue="id" [filter]="true" filterBy="value" [showClear]="true" styleClass="w-full" [loading]="loadingAddressCities" [disabled]="disableCitySelect('address')"></p-select>
                                    <label for="city">Localidad</label>
                                </p-floatlabel>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Contact & Security Section -->
                <div class="surface-border border-top-1 pt-4">
                    <h3 class="text-xs font-semibold text-color-secondary uppercase tracking-widest mb-4 mt-0">Contacto y Seguridad</h3>
                    <div class="flex flex-column gap-4">
                        
                        <div *ngIf="checkShowControl('register', 'resultEmails')">
                            <label class="text-xs font-medium text-color-secondary mb-2 block">Emails para Resultados</label>
                            <p-chips id="resultEmails" formControlName="resultEmails" styleClass="w-full" inputStyleClass="w-full" placeholder="Presiona Enter para agregar"></p-chips>
                        </div>

                        <div *ngIf="checkShowControl('register', 'phones')">
                            <label class="text-xs font-medium text-color-secondary mb-2 block">Teléfonos</label>
                            <p-chips id="phones" formControlName="phones" styleClass="w-full" inputStyleClass="w-full" placeholder="Presiona Enter para agregar"></p-chips>
                        </div>

                        <div class="grid grid-nogutter gap-3">
                            <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)" *ngIf="checkShowControl('register', 'password')">
                                <p-floatlabel>
                                    <p-password id="password" formControlName="password" [toggleMask]="true" [feedback]="false" styleClass="w-full" inputStyleClass="w-full"></p-password>
                                    <label for="password">Contraseña</label>
                                </p-floatlabel>
                            </div>

                            <div class="col-12 md:col-fixed" style="width: calc(50% - 0.75rem)" *ngIf="checkShowControl('register', 'confirmPassword')">
                                <p-floatlabel>
                                    <p-password id="confirmPassword" formControlName="confirmPassword" [toggleMask]="true" [feedback]="false" styleClass="w-full" inputStyleClass="w-full"></p-password>
                                    <label for="confirmPassword">Confirmar Contraseña</label>
                                </p-floatlabel>
                            </div>
                        </div>

                        <div class="flex flex-column gap-2">
                             <p-floatlabel *ngIf="checkShowControl('register', 'email')">
                                <input pInputText id="email" formControlName="email" class="w-full" />
                                <label for="email">Email de registro</label>
                            </p-floatlabel>

                             <div class="flex gap-2" *ngIf="formCodeVisible()">
                                <p-floatlabel class="flex-grow-1">
                                    <input pInputText id="code" formControlName="code" class="w-full" />
                                    <label for="code">Código de verificación</label>
                                </p-floatlabel>
                            </div>

                            <p-button [label]="nameButton()" [disabled]="disabledButtonCode()" [loading]="isLoading" (onClick)="validationMail(this.formCodeVisible())" styleClass="p-button-secondary p-button-outlined w-full"></p-button>
                        </div>
                    </div>
                </div>

                <!-- Action Section -->
                <div class="mt-2 flex flex-column gap-3">
                    <!-- Honeypot -->
                    <input type="text" formControlName="website" class="honeypot" tabindex="-1" autocomplete="off" style="opacity: 0; position: absolute; top: -9999px; left: -9999px;">
                    <p-button label="Registrarme" type="button" styleClass="w-full p-button-lg" [disabled]="(form.invalid || isLoading) && !validationEmailSignal()" [loading]="isLoading" icon="pi pi-user-plus" (onClick)="save()"></p-button>
                    <p-button label="Volver al Login" severity="secondary" [outlined]="true" (onClick)="toLogin()" [disabled]="isLoading" styleClass="w-full"></p-button>
                </div>
            </form>

            <div class="mt-5 pt-4 border-top-1 surface-border w-full flex justify-content-center">
                <app-powered-by></app-powered-by> 
            </div>

        </div>
    </div>
</div>
